module.exports = "../dist/frontend/images/white/carousel/map.svg?ad35e4f4651d09bedca7fd2369b8b715";